export interface StatusDefinition {
    value: string
    description: string
    // Statuses this one can be reached from
    available: string[]
    needReason?: boolean
}

export type StatusTone = 'success' | 'processing' | 'warning' | 'error' | 'default'

const tones: Record<string, StatusTone> = {
    completed: 'success',
    approved: 'success',
    active: 'success',
    enabled: 'success',
    pending: 'processing',
    pending_docs: 'processing',
    pending_approval: 'processing',
    awaiting_funds: 'processing',
    under_review: 'processing',
    processing: 'processing',
    in_transit: 'processing',
    suspended: 'warning',
    dormant: 'warning',
    documents_need_resubmission: 'warning',
    rejected: 'error',
    failed: 'error',
    disabled: 'error',
    closed: 'error',
    terminated: 'error',
}

export const toneOf = (status: string): StatusTone => tones[status] ?? 'default'

// The current status plus every status reachable from it
export const allowedStatuses = <T extends StatusDefinition>(statuses: T[], current: string): T[] =>
    statuses.filter((status) => status.available.includes(current) || status.value === current)

// Label from the definitions, falling back to 'in_transit' -> 'In transit' for statuses the simulator doesn't know
export const statusLabel = (status: string, statuses: StatusDefinition[] = []): string => {
    const definition = statuses.find((each) => each.value === status)
    if (definition) return definition.description
    const words = status.replace(/_/g, ' ')
    return words.charAt(0).toUpperCase() + words.slice(1)
}
